angular.module('impactx.tagcloud').controller('TagCloudCtrl', '$scope', 'dataGen', '$redirect', 'searchFilter', TagCloudCtrl);

function TagCloudCtrl($scope, dataGen, $redirect, searchFilter) {

    $scope.defaultMinFontSize = $scope.minFontSize ? $scope.minFontSize : 20;
    $scope.defaultMaxFontSize = $scope.maxFontSize ? $scope.maxFontSize : 60;

    $scope.getPageData = function() {
        if (!$scope.timePeriod)
        {
            //last 90 days.
            $scope.timePeriod = 8;
        }
        dataGen.getData($scope, {timeperiod: $scope.timePeriod}, "/monitor/tagcloud").then(function() {
            if ($scope.data.searchStringData)
            {
                $scope.createSearchWordCloud();
            }
        });
    };

    $scope.getPageData();

    $scope.createSearchWordCloud = function() {
        $(".search-words").empty();
        var fill = d3.scale.category20();
        d3.layout.cloud().size([$scope.width, $scope.height])
            .words($scope.generateSearchWordData())
            .text(function(d) {
                return d.word;
            })
            .fontSize(function(d) {
                return d.size;
            })
            .rotate(function() {
                return 0
            })
            .font("Arial")
            .fontSize(function(d) {
                return d.size;
            })
            .on("end", draw)
            .start();

        function draw(words) {
            d3.select(".search-words").append("svg")
                .attr("width", $scope.width)
                .attr("height", $scope.height)
                .append("g")
                .attr("transform", "translate(" + $scope.width / 2 + ", " + $scope.height / 2 + ")")
                .selectAll("text")
                .data(words)
                .enter().append("text")
                .style("font-size", function(d) {
                    return d.size + "px";
                })
                .style("font-family", "Arial")
                .style("fill", function(d, i) {
                    return fill(i);
                })
                .attr("text-anchor", "middle")
                .attr("transform", function(d) {
                    return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
                })
                .text(function(d) {
                    return d.text;
                })
                .on("click", function(d) {
                    searchFilter.searchInput = d.text;
                    $redirect.redirectTo(null, searchFilter.pageSearchAll);
                    $scope.$evalAsync();
                });
        }
    };
    $scope.generateSearchWordData = function() {
        var words = [];
        // var totalAmount = $scope.data.searchStringData.totalAmount;
        var numberOfWords = $scope.data.searchStringData.entries.length;
        if(numberOfWords > 0) {
            var i = 0;
            var max = $scope.data.searchStringData.entries[0].amount;
            var min = $scope.data.searchStringData.entries[$scope.data.searchStringData.entries.length - 1].amount;
            while(i < numberOfWords) {
                words.push({
                    word: $scope.data.searchStringData.entries[i].searchString,
                    size: $scope.getSize(i, min, max)
                });
                i++;
            }
        }

        return words;
    };
    $scope.getSize = function(i, min, max) {
        var size = ((($scope.data.searchStringData.entries[i].amount - min)
        * ($scope.defaultMaxFontSize - $scope.defaultMinFontSize)) / (max - min))
        + $scope.defaultMinFontSize;
        return size ? size : $scope.defaultMinFontSize;
    };
}